import React, {Component, ReactNode} from 'react';
import {inject, observer} from 'mobx-react';
import {uploadDocumentsLink} from 'app/components/DocumentsUpload/upload_documents';
import UserNavBottomOriginal from 'site_version/com/userNavBottom';

interface UserNavBottomProps {
    onClose?: () => void;
}

@inject('userStore')
@observer
export default class UserNavBottom extends Component<UserNavBottomProps> {
    render(): ReactNode {
        return <div className="user-nav">
            {uploadDocumentsLink()}
            <UserNavBottomOriginal onClose={this.props.onClose}/>
        </div>;
    }
}
